/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ToolDetailLevel } from './ToolDetailLevel';

export type ListSchemaPropertiesInput = {
    /**
     * Optional namespace id or name scope for deterministic schema inspection.
     */
    namespace_id?: (string | null);
    /**
     * Optional entity scope for effective per-entity property schema inspection. By default this still allows cross-namespace expression authoring; set local_only for the entity-native catalog.
     */
    entity_id?: (string | null);
    /**
     * With entity_id, restrict results to the entity namespace after applying global/assigned visibility. Use for selected-entity workbook row catalogs and LX.FIELD.LIST_ENTITY-style helper sheets.
     */
    local_only?: boolean;
    /**
     * Optional case-insensitive substring match across name, pointer, description, or group name.
     */
    search?: (string | null);
    /**
     * Optional exact field group id filter. Use schema_groups_list to discover valid group ids.
     */
    group_id?: (string | null);
    /**
     * Optional exact field group name filter, e.g. Income Statement.
     */
    group_name?: (string | null);
    /**
     * Use model_order when building financial statement rows from a field group, or prevalence when ranking portfolio-wide fields.
     */
    sort?: ListSchemaPropertiesInput.sort;
    /**
     * Optional filter on property globality. Use `true` to focus on portfolio-wide fields and avoid assigned line-item noise.
     */
    is_global?: (boolean | null);
    /**
     * Optional property type filter applied before limiting. Use this to suppress unwanted line-item classes.
     */
    property_types?: (Array<string> | null);
    /**
     * Optional minimum prevalence_score to include a property. Use this to suppress sparse long-tail fields (e.g. line items populated for a handful of entities) when the caller wants portfolio-wide KPIs.
     */
    min_prevalence?: (number | null);
    /**
     * Return shortlist property rows by default. Use `full` for richer property metadata.
     */
    detail_level?: ToolDetailLevel;
    limit?: number;
};

export namespace ListSchemaPropertiesInput {

    /**
     * Use model_order when building financial statement rows from a field group, or prevalence when ranking portfolio-wide fields.
     */
    export enum sort {
        NAME = 'name',
        MODEL_ORDER = 'model_order',
        PREVALENCE = 'prevalence',
    }


}

